<template>
	<div>
		<div class="banxx" style="background:url('/images/yrxm.jpg') no-repeat center center; background-size:cover">
		</div>
		<vue-menu :menu="menu" title="解决方案" :menuWidth="350"></vue-menu>
	</div>
</template>

<script>
	import vueMenu from '@/components/vue-menu2.vue'
	export default {
		data() {
			return {
				menu: [{
					title: '本科教育解决方案',
					children: [{
						title: '国家级一流课程建设方案',
						path: '/home/program/page8'
					}, {
						title: '虚拟仿真实训室建设方案',
						path: '/home/program/page9'
					}]
				}, {
					title: '职业教育解决方案',
					children: [{
						title: '医学虚拟仿真实训室建设',
						path: '/home/program/page3'
					},{
						title: '国家级示范性实训基地建设',
						path: '/home/program/page10'
					}]
				}, 
				// {
				// 	title: '1+x解决方案' ,
				// 	children: [{
				// 		title: '智慧零售',
				// 		path: '/home/program/page5'
				// 	},{
				// 		title: '1+X 幼儿照护',
				// 		path: '/home/program/page6'
				// 	},{
				// 		title: '1+X 老年照护',
				// 		path: '/home/program/page7'
				// 	}]
				// },
				]
			}
		},
		components: {
			vueMenu
		}
	}
</script>

<style scoped >
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	hr,
	dt,
	dd,
	dl {
		font-size: 14px;
		margin: 0;
		padding: 0;
		font-weight: normal;
	}

	.banxx {
		height: 150px;
	}
</style>
